import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';

import PageContainer from '@deliveroo/consumer-component-library/components/PageContainer';
import CuisineRestaurantsContainer from '../../../containers/CuisineRestaurantsContainer';
import RestaurantReviewsContainer from '../../../containers/RestaurantReviewsContainer';
import LocationListContainer from '../../../containers/CuisineLocationListContainer';
import RecommendedCuisinesContainer from '../../../containers/RecommendedCuisinesContainer';
import PageFooter from '../../../containers/PageFooter';
import CuisinePageHeroContainer from '../../../containers/CuisinePageHeroContainer';
import CuisinePageFooter from '../../../containers/CuisinePageFooterContainer';
import Page from '../../../containers/Page';
import HowDeliverooWorksContainer from '../../../containers/HowDeliverooWorksContainer';
import AnalyticsTrackers from '../../../containers/AnalyticsTrackers';
import { alternateLocaleUrlsSelector } from '../../../selectors/cuisineSelectors';
import { hasQueryParamsSelector } from '../selectors';
import { isCuisineRestaurantsOn, getCuisineLandingPagePath } from '../../../utils/pages/cuisines';

class Cuisines extends Component {
  render() {
    const {
      pageTitle,
      metaDescription,
      landingPagePath,
      cuisineRestaurantsOn,
      alternateLocales,
      robots,
    } = this.props;

    return (
      <Page
        pageName="cuisine"
        color="anchovy"
        pageTitle={pageTitle}
        metaDescription={metaDescription}
        pagePath={landingPagePath}
        alternateLocales={alternateLocales}
        robots={robots}
      >
        <CuisinePageHeroContainer />
        {cuisineRestaurantsOn && <CuisineRestaurantsContainer />}

        <PageContainer>
          <PageContainer fullWidth="mobile-only">
            <RestaurantReviewsContainer />
          </PageContainer>
        </PageContainer>

        <HowDeliverooWorksContainer />

        <PageContainer>
          <LocationListContainer />

          <PageContainer fullWidth="mobile-only">
            <RecommendedCuisinesContainer />
          </PageContainer>
        </PageContainer>

        <CuisinePageFooter />
        <PageFooter />
        <AnalyticsTrackers />
      </Page>
    );
  }
}

Cuisines.propTypes = {
  pageTitle: PropTypes.string.isRequired,
  metaDescription: PropTypes.string.isRequired,
  landingPagePath: PropTypes.string.isRequired,
  cuisineRestaurantsOn: PropTypes.bool,
  alternateLocales: PropTypes.arrayOf(
    PropTypes.shape({
      href: PropTypes.string.isRequired,
      hrefLang: PropTypes.string.isRequired,
    }),
  ).isRequired,
  robots: PropTypes.string,
};

Cuisines.defaultProps = {
  cuisineRestaurantsOn: false,
  robots: undefined,
};

function mapStateToProps(state) {
  const { city, pageTitle, metaDescription } = state.cuisine;
  const alternateLocales = alternateLocaleUrlsSelector(state);
  const robots = hasQueryParamsSelector(state) ? 'noindex, nofollow' : undefined;

  return {
    city,
    pageTitle,
    metaDescription,
    landingPagePath: getCuisineLandingPagePath(state.request),
    cuisineRestaurantsOn: isCuisineRestaurantsOn(state.config),
    alternateLocales,
    robots,
  };
}

export default connect(mapStateToProps)(Cuisines);
